import { CartAddEvent } from '@theme/events';
class AlaCartPairing extends HTMLElement {
  connectedCallback(){this.addEventListener('submit',this.submit);}
  disconnectedCallback(){this.removeEventListener('submit',this.submit);}
  submit=async(event)=>{
    event.preventDefault();
    if(this.busy)return;
    this.busy=true;
    const form=event.target,button=form.querySelector('button'),status=this.querySelector('[role=status]');
    const label=button.innerHTML;
    button.disabled=true;button.textContent=this.dataset.adding;status.textContent='';
    try{
      const data=new FormData(form);
      const ids=[...new Set([...document.querySelectorAll('cart-items-component')].map(e=>e.dataset.sectionId).filter(Boolean))];
      data.set('sections',ids.slice(0,5).join(','));data.set('sections_url',location.pathname);
      const response=await fetch(form.action,{method:'POST',body:data,headers:{Accept:'application/json'}});
      const result=await response.json();
      if(!response.ok||result.status)throw new Error(result.description||this.dataset.error);
      status.textContent=this.dataset.added;
      document.dispatchEvent(new CartAddEvent({},String(data.get('id')),{source:'product-form-component',itemCount:1,sections:result.sections}));
    }catch(error){status.textContent=error.message||this.dataset.error;}
    finally{this.busy=false;button.disabled=false;button.innerHTML=label;}
  }
}
if(!customElements.get('ala-cart-pairing'))customElements.define('ala-cart-pairing',AlaCartPairing);
